import React from "react";
import tw from "tailwind-styled-components";
import { useFormik } from "formik";
import Loading from "../Loading";
import { InputGroup, Label, SubmitBtn } from "../Styles/InputStyles";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Model from "../Model";
import * as Yup from "yup";
import { toast } from "react-toastify";

const EditSetting = ({
    editSettingMutate,
    editSettingLoading,
    setEditSetting,
    selectedData,
})=>{
const SubmitHandler = (values) => {
    editSettingMutate(values);
    };

    const formik = useFormik({
    initialValues: {
        whatsApp: selectedData?.whatsApp || 0,
        rentReminder: selectedData?.rentReminder || 0,
        markPaidNotification: selectedData?.markPaidNotification || 0,
        onboardWelcome: selectedData?.onboardWelcome || 0,
        footer: selectedData?.footer || "",
        whatsappOnboardingTemplate: selectedData?.whatsappOnboardingTemplate || "",
        ios: selectedData?.ios || "",
        android: selectedData?.android || "",
    },
    validationSchema: Yup.object().shape({
        whatsApp: Yup.number().required("Select an option"),
        rentReminder: Yup.number().required("Select an option"),
        markPaidNotification: Yup.number().required("Select an option"),
        onboardWelcome: Yup.number().required("Select an option"),
        footer: Yup.string().required("Footer is required"),
        whatsappOnboardingTemplate: Yup.string().required("Template is required"),
        // ios: Yup.string().required("Please Enter Text"),
        // android: Yup.string().required("Please Enter Text"),
    }),
    onSubmit: SubmitHandler,
    enableReinitialize: true,
    });

    return (
    <Model width={`w-11/12 max-w-lg`} setOpenModel={setEditSetting}>
      {editSettingLoading ? (
        <div className="w-full h-full">
          <Loading />
        </div>
      ) : (
        <Wrapper>
          <Title>Edit Setting</Title>
          <form onSubmit={formik.handleSubmit}>
            <Wrapper>
              <CombineInputGroup>
                <InputGroup>
                  <Label htmlFor="whatsApp">WhatsApp</Label>
                  <FieldWrapper $select={true}>
                    <Select
                      name="whatsApp"
                      id="whatsApp"
                      value={formik.values.whatsApp}
                      onChange={formik.handleChange}
                      className="w-full pl-2"
                      style={{ height: "40px" }}
                      displayEmpty
                    >
                      <MenuItem value="0">No</MenuItem>
                      <MenuItem value="1">Yes</MenuItem>
                    </Select>
                    {formik.touched.whatsApp &&
                      formik.errors.whatsApp && (
                        <p className="text-rose-600 text-sm">
                          {formik.errors.whatsApp}
                        </p>
                      )}
                  </FieldWrapper>
                </InputGroup>

                <InputGroup>
                  <Label htmlFor="rentReminder">Rent Reminder</Label>
                  <FieldWrapper $select={true}>
                    <Select
                      name="rentReminder"
                      id="rentReminder"
                      value={formik.values.rentReminder}
                      onChange={formik.handleChange}
                      className="w-full pl-2"
                      style={{ height: "40px" }}
                      displayEmpty
                    >
                      <MenuItem value="0">No</MenuItem>
                      <MenuItem value="1">Yes</MenuItem>
                    </Select>
                    {formik.touched.rentReminder &&
                      formik.errors.rentReminder && (
                        <p className="text-rose-600 text-sm">
                          {formik.errors.rentReminder}
                        </p>
                      )}
                  </FieldWrapper>
                </InputGroup>
              </CombineInputGroup>

              <CombineInputGroup>
                <InputGroup>
                    <Label htmlFor="markPaidNotification">Mark Paid</Label>
                    <FieldWrapper $select={true}>
                      <Select
                        name="markPaidNotification"
                        id="markPaidNotification"
                        value={formik.values.markPaidNotification}
                        onChange={formik.handleChange}
                        className="w-full pl-2"
                        style={{ height: "40px" }}
                        displayEmpty
                      >
                        <MenuItem value="0">No</MenuItem>
                        <MenuItem value="1">Yes</MenuItem>
                      </Select>
                      {formik.touched.markPaidNotification &&
                        formik.errors.markPaidNotification && (
                          <p className="text-rose-600 text-sm">
                            {formik.errors.markPaidNotification}
                          </p>
                        )}
                    </FieldWrapper>
                  </InputGroup>

                    <InputGroup>
                    <Label htmlFor="onboardWelcome">Onboard Welcome</Label>
                    <FieldWrapper $select={true}>
                      <Select
                        name="onboardWelcome"
                        id="onboardWelcome"
                        value={formik.values.onboardWelcome}
                        onChange={formik.handleChange}
                        className="w-full pl-2"
                        style={{ height: "40px" }}
                        displayEmpty
                      >
                        <MenuItem value="0">No</MenuItem>
                        <MenuItem value="1">Yes</MenuItem>
                      </Select>
                      {formik.touched.onboardWelcome &&
                        formik.errors.onboardWelcome && (
                          <p className="text-rose-600 text-sm">
                            {formik.errors.onboardWelcome}
                          </p>
                        )}
                    </FieldWrapper>
                  </InputGroup>
                  </CombineInputGroup>

                  <CombineInputGroup>
                  <InputGroup>
                  <Label htmlFor="whatsappOnboardingTemplate">Template</Label>
                  <FieldWrapper>
                      <Input
                      type="text"
                      name="whatsappOnboardingTemplate"
                      id="whatsappOnboardingTemplate"
                      autoComplete="off"
                      value={formik.values.whatsappOnboardingTemplate}
                      onChange={formik.handleChange}
                      />
                      {formik.touched.whatsappOnboardingTemplate && formik.errors.whatsappOnboardingTemplate && (
                      <p className="text-rose-600 text-sm">
                          {formik.errors.whatsappOnboardingTemplate}
                      </p>
                      )}
                  </FieldWrapper>
                  </InputGroup>

                  <InputGroup>
                  <Label htmlFor="footer">Footer</Label>
                  <FieldWrapper>
                      <Input
                      type="text"
                      name="footer"
                      id="footer"
                      autoComplete="off"
                      value={formik.values.footer}
                      onChange={formik.handleChange}
                      />
                      {formik.touched.footer && formik.errors.footer && (
                      <p className="text-rose-600 text-sm">
                          {formik.errors.footer}
                      </p>
                      )}
                  </FieldWrapper>
                  </InputGroup>
              </CombineInputGroup>

                <CombineInputGroup>
                  <InputGroup>
                    <Label htmlFor="android">Android</Label>
                    <FieldWrapper>
                        <Input
                        type="text"
                        name="android"
                        id="android"
                        autoComplete="off"
                        value={formik.values.android}
                        onChange={formik.handleChange}
                        />
                        {formik.touched.android && formik.errors.android && (
                        <p className="text-rose-600 text-sm">
                            {formik.errors.android}
                        </p>
                        )}
                    </FieldWrapper>
                    </InputGroup>

                  <InputGroup>
                    <Label htmlFor="ios">Ios</Label>
                    <FieldWrapper>
                        <Input
                        type="text"
                        name="ios"
                        id="ios"
                        autoComplete="off"
                        value={formik.values.ios}
                        onChange={formik.handleChange}
                        />
                        {formik.touched.ios && formik.errors.ios && (
                        <p className="text-rose-600 text-sm">
                            {formik.errors.ios}
                        </p>
                        )}
                    </FieldWrapper>
                  </InputGroup>
                </CombineInputGroup>
            </Wrapper>

            <BtnWrapper>
              <SubmitBtn type="submit">Update</SubmitBtn>
            </BtnWrapper>
          </form>
        </Wrapper>
      )}
    </Model>
  );
};

const BtnWrapper = tw.div`w-full flex items-center justify-center space-x-10 mt-8`;
const Title = tw.h2`text-lg md:text-xl lg:text-2xl text-gray-600 font-medium mb-6 text-center`;
const Wrapper = tw.div`px-1  space-y-4`;
const FieldWrapper = tw.div`w-full`;
const CombineInputGroup = tw.div`flex space-x-7`;
const Input = tw.input`truncate border border-gray-300 border-m rounded pl-2 focus:ring-1 focus:ring-sky-600 focus:border-sky-600 focus:outline-none duration-200`;
export default EditSetting;